import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  "ar": {
      "translation": {
            "Data Management": "إدارة البيانات",
            "Select Filter": "حدد تصفية",
            "Select ": "يختار",
            "Apply": "يتقدم",
            "Reset": "إعادة ضبط",
            "Activated Clients": "العملاء المنشطين",
            "Deactivated Clients": "العملاء المعطلين",
            "Search": "يبحث",
            "Cases": "حالات",
            "Page of": "صفحة ال",
            "Go to page": "انتقل إلى صفحة",
            "Show": "يعرض",
            "Name": "اسم",
            "Age": "عمر",
            "Gender": "جنس",
            "Address": "عنوان",
            "Deacitivate": "إلغاء التنشيط",
            "Client status has been set to inactive": "تم ضبط حالة العميل على غير نشط",
            "Close": "يغلق",
            "Activate": "تفعيل",
            "Client status has been set to activate": "تم ضبط حالة العميل للتنشيط",
            "Data Upload": "تحميل البيانات",
            "Data Export": "تصدير البيانات",
            "Choose File": "اختر ملف",
            "No file chosen": "لم تقم باختيار ملف",
            "Download Template": "تحميل القالب",
            "Upload": "رفع",
            "Success": "نجاح",
            "File uploaded sucessfully": "تم تحميل الملف بنجاح",
            "Data Upload Logs": "سجلات تحميل البيانات",
            "Uploaded by": "تم الرفع بواسطة",
            "Total Entries": "إجمالي الإدخالات",
            "Valid": "صالح",
            "Invalid": "غير صالح",
            "Upload Date": "تاريخ الرفع",
            "Response File": "ملف الرد",
            "User Management": "إدارةالمستخدم",
            "First Name": "الاسم الأول",
            "First name is required": "الإسم الأول مطلوب",
            "Last Name": "اسم العائلة",
            "Last name is required": "إسم العائلة مطلوب",
            "Email": "بريد إلكتروني",
            "Phone Number": "رقم التليفون",
            "Status": "حالة",
            "Active": "نشيط",
            " Inactive": "غير نشط",
            "Edit": "يحرر",
            "Add User": "إضافة مستخدم",
            "Edit User": "تحرير المستخدم",
            "Username": "اسم المستخدم",
            "Username is required": "اسم المستخدم مطلوب",
            "Mobile Number": "رقم الهاتف المحمول",
            "Minimum length 10": "الحد الأدنى للطول 10",
            "Role": "دور",
            "Role is required": "الدور مطلوب",
            "Data Capture Unit": "وحدة التقاط البيانات",
            "Facility User": "مستخدم المنشأة",
            "Healthworker": "العامل الصحي",
            "Operator": "المشغل أو العامل",
            "Patient Role": "دور المريض",
            "ReadOnlyUser": "قراءة فقط المستخدم",
            "Superuser": "المستخدم المتميز",
            "Email Address": "عنوان البريد الإلكتروني",
            "Invalid email": "بريد إلكتروني خاطئ",
            "Password": "كلمة المرور",
            "Password is required": "كلمة المرور مطلوبة",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "يجب أن تحتوي كلمة المرور على حرف صغير واحد وحرف كبير واحد ورقم واحد ورمز واحد على الأقل",
            "Please include an '@' in the email address": "يرجى تضمين \"@\" في عنوان البريد الإلكتروني",
            "Add": "يضيف",
            "Update": "تحديث",
            "Facility Management": "إدارة المرافق",
            "Create New Facility": "إنشاء منشأة جديدة",
            "New Facility": "منشأة جديدة",
            "Add Facility": "إضافة منشأة",
            "Facility Code": "رمز المنشأة",
            "Facility Name": "إسم المنشأة",
            "Facility name is required": "اسم المنشأة مطلوب",
            "Facility Address": "عنوان المنشأة",
            "Facility address is required": "عنوان المنشأة مطلوب",
            "Facility Email": "البريد الإلكتروني للمنشأة",
            "Email is required": "البريد الالكتروني مطلوب",
            "Facility Phone Number": "رقم هاتف المنشأة",
            "Phone number must be exactly 10 digits.": "يجب أن يتكون رقم الهاتف من 10 أرقام بالضبط.",
            "Select Province": "اختر المقاطعة",
            "Select District": "اختر المنطقة",
            "Create New Organization": "إنشاء منظمة جديدة",
            "Add Organization": "أضف منظمة",
            "Organization Name": "اسم المنظمة",
            "Organization name is required": "اسم المنظمة مطلوب",
            "Organization Parent": "المنظمة الأم",
            "Select Country": "حدد الدولة",
            "Error": "خطأ",
            "Someting went wrong.\n": "حدث خطأ ما.",
            "Edit Facility": "تحرير المنشأة",
            "Logout": "تسجيل خروج",
            "Organization Units": "الوحدات التنظيمية",
            "Select": "يختار",
            "Apply ": "يتقدم",
            "Total number of unique people got registered on the platform.": "إجمالي عدد الأشخاص الفريدين الذين تم تسجيلهم على المنصة.",
            "Total number of T1Ds patients on active treatment": "العدد الإجمالي لمرضى T1Ds الذين يتلقون العلاج الفعال",
            "Total number of T1Ds patients who are not active on treatment.": "العدد الإجمالي لمرضى T1Ds غير النشطين في العلاج.",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "مرضى السكري الذين كانت آخر قيمة مسجلة لـ HBA1C لديهم أقل من أو تساوي 7",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "مرضى السكري الذين كانت آخر قيمة مسجلة لـ HBA1C لديهم أكبر من أو تساوي 8",
            "Chart context menu": "قائمة سياق الرسم البياني",
            "View in full screen": "عرض في كامل الشاشة",
            "Print chart": "الرسم البياني للطباعة",
            "Download PNG image": "تحميل صورة PNG",
            "Download JPEG image": "تنزيل صورة JPEG",
            "Download PDF document": "تحميل وثيقة PDF",
            "Download SVG vector image": "تنزيل صورة متجهة بصيغة SVG",
            "Download CSV": "قم بتنزيل ملف CSV",
            "Download XLS": "تحميل XLS",
            "View data table": "عرض جدول البيانات",
            "Total Number Patients- Male": "إجمالي عدد المرضى ذكور",
            "Total Number Patients- Female": "العدد الإجمالي للمرضى إناث",
            "Total Number Patients- Other": "إجمالي عدد المرضى - أخرى",
            "To": "ل",
            "Above": "فوق",
            "Below": "أقل",
            "Smoking": "التدخين",
            "Mental Health Disorder": "اضطراب الصحة العقلية",
            "Pubertal Stage": "مرحلة البلوغ",
            "Celiac Disease": "مرض الاضطرابات الهضمية",
            "Hypoglynemic Events": "أحداث نقص السكر في الدم",
            "Healthy": "صحيح",
            "Underweight": "نقص الوزن",
            "Overweight": "زيادة الوزن",
            "Obesity": "بدانة",
            "Pathway": "مسار",
            "Total Enrolled": "إجمالي المسجلين",
            "Count ": "عدد",
            "Percentage": "نسبة مئوية",
            "Referred For Further Investigation": "تمت إحالته لمزيد من التحقيق",
            "Not Referred": "لم تتم الإشارة إليه",
            "Diagnosed ": "تم تشخيصه",
            "Not Diagnosed ": "لم يتم تشخيصه",
            "On Treatment/ Medical Therapy": "على العلاج/ العلاج الطبي",
            "Medical Therapy Not Initiated ": "العلاج الطبي لم يبدأ",
            "Cured ": "علاجه",
            "Not Cured ": "لم يتم علاجه",
            "Alerts": "التنبيهات",
            "All": "الجميع",
            "All Follow Alert": "الكل يتبع التنبيه",
            "Days": "أيام",
            "Details": "تفاصيل",
            "Follow Up Alert": "تنبيه المتابعة",
          "Total people enrolled": "إجمالي الأشخاص المسجلين",
          "Total T1Ds patient on treatment": "إجمالي مرضى T1Ds الذين يخضعون للعلاج",
          "Total T1D Inactive patient ": "إجمالي T1D مريض غير نشط",
          "Distribution Of T1D Patients By Gender": "توزيع مرضى T1D حسب الجنس",
          "Distribution Of T1D Patients By Age group": "توزيع مرضى T1D حسب الفئة العمرية",
          "BMI value distribution": "توزيع قيمة مؤشر كتلة الجسم",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "حالة التحكم في مرض السكري على أساس نسبة HbA1C\n- السيطرة على مرض السكري\n- مرض السكري غير المنضبط",
          "Total Patients With Co-Morbidities": "إجمالي المرضى الذين يعانون من أمراض مصاحبة",
          "Complication Reporting Rate": "معدل الإبلاغ عن المضاعفات",
          "Home": "بيت",
          "Pathway": "مسار",
          "Linelist": "القائمة الخطية",
          "Alerts": "التنبيهات",
          "Select filter": "حدد عامل التصفية",
          "Dashboard": "لوحة القيادة",
          "Guinea": "غينيا",
          "Data upload": "تحميل البيانات",
          "Data management": "إدارة البيانات",
          "User management": "إدارةالمستخدم",
          "Facility management": "إدارة المرافق",
          "Activated clients": "العملاء المنشطين",
          "Deactivated clients": "العملاء المعطلين",
          "Search": "يبحث",
          "Go to page": "انتقل إلى صفحة",
          "Page": "صفحة",
          "Of": "ل",
          "Cases": "حالات",
          "Show": "يعرض",
          "UIC": "UIC",
          "Name": "اسم",
          "Age": "عمر",
          "Gender": "جنس",
          "Address": "عنوان",
          "Deactivate": "إلغاء التنشيط",
          "Logout": "تسجيل خروج",
          "Organisation":"منظمة"
      }
  },
  "en": {
      "translation": {
            "Data Management": "Data Management ",
            "Select Filter": "Select Filter",
            "Select ": "Select ",
            "Apply": "Apply",
            "Reset": "Reset",
            "Activated Clients": "Activated Clients",
            "Deactivated Clients": "Deactivated Clients",
            "Search": "Search",
            "Cases": "Cases",
            "Page of": "Page of",
            "Go to page": "Go to page",
            "Show": "Show",
            "Name": "Name",
            "Age": "Age",
            "Gender": "Gender",
            "Address": "Address",
            "Deacitivate": "Deacitivate",
            "Client status has been set to inactive": "Client status has been set to inactive",
            "Close": "Close",
            "Activate": "Activate",
            "Client status has been set to activate": "Client status has been set to activate",
            "Data Upload": "Data Upload ",
            "Choose File": "Choose File",
            "No file chosen": "No file chosen",
            "Download Template": "Download Template",
            "Upload": "Upload",
            "Success": "Success",
            "File uploaded sucessfully": "File uploaded sucessfully",
            "Data Upload Logs": "Data Upload Logs",
            "Uploaded by": "Uploaded by",
            "Total Entries": "Total Entries",
            "Valid": "Valid",
            "Invalid": "Invalid",
            "Upload Date": "Upload Date",
            "Response File": "Response File",
            "User Management": "User Management",
            "First Name": "First Name",
            "First name is required": "First name is required",
            "Last Name": "Last Name",
            "Last name is required": "Last name is required",
            "Email": "Email",
            "Phone Number": "Phone Number",
            "Status": "Status",
            "Active": "Active",
            " Inactive": " Inactive",
            "Edit": "Edit",
            "Add User": "Add User",
            "Edit User": "Edit User",
            "Username": "Username",
            "Username is required": "Username is required",
            "Mobile Number": "Mobile Number",
            "Minimum length 10": "Minimum length 10",
            "Role": "Role",
            "Role is required": "Role is required",
            "Data Capture Unit": "Data Capture Unit",
            "Facility User": "Facility User",
            "Healthworker": "Healthworker",
            "Operator": "Operator",
            "Patient Role": "Patient Role",
            "ReadOnlyUser": "ReadOnlyUser",
            "Superuser": "Superuser",
            "Email Address": "Email Address",
            "Invalid email": "Invalid email",
            "Password": "Password",
            "Password is required": "Password is required",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character",
            "Please include an '@' in the email address": "Please include an '@' in the email address",
            "Add": "Add",
            "Update": "Update",
            "Facility Management": "Facility Management",
            "Create New Facility": "Create New Facility",
            "New Facility": "New Facility",
            "Add Facility": "Add Facility",
            "Facility Code": "Facility Code",
            "Facility Name": "Facility Name",
            "Facility name is required": "Facility name is required",
            "Facility Address": "Facility Address",
            "Facility address is required": "Facility address is required",
            "Facility Email": "Facility Email",
            "Email is required": "Email is required",
            "Facility Phone Number": "Facility Phone Number",
            "Phone number must be exactly 10 digits.": "Phone number must be exactly 10 digits.",
            "Select Province": "Select Province",
            "Select District": "Select District",
            "Create New Organization": "Create New Organization",
            "Add Organization": "Add Organization",
            "Organization Name": "Organization Name",
            "Organization name is required": "Organization name is required",
            "Organization Parent": "Organization Parent",
            "Select Country": "Select Country",
            "Error": "Error",
            "Someting went wrong.\n": "Someting went wrong.\n",
            "Edit Facility": "Edit Facility",
            "Logout": "Logout",
            "Organization Units": "Organization Units",
            "Select": "Select",
            "Apply ": "Apply ",
            "Total number of unique people got registered on the platform.": "Total number of unique people got registered on the platform.",
            "Total number of T1Ds patients on active treatment": "Total number of T1Ds patients on active treatment",
            "Total number of T1Ds patients who are not active on treatment.": "Total number of T1Ds patients who are not active on treatment.",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "Diabetic patients who's last HBA1C recorded value is less than or equal to 7",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8",
            "Chart context menu": "Chart context menu",
            "View in full screen": "View in full screen",
            "Print chart": "Print chart",
            "Download PNG image": "Download PNG image",
            "Download JPEG image": "Download JPEG image",
            "Download PDF document": "Download PDF document",
            "Download SVG vector image": "Download SVG vector image",
            "Download CSV": "Download CSV",
            "Download XLS": "Download XLS",
            "View data table": "View data table",
            "Total Number Patients- Male": "Total Number Patients- Male",
            "Total Number Patients- Female": "Total Number Patients- Female",
            "Total Number Patients- Other": "Total Number Patients- Other",
            "To": "To",
            "Above": "Above",
            "Below": "Below",
            "Smoking": "Smoking",
            "Mental Health Disorder": "Mental Health Disorder",
            "Pubertal Stage": "Pubertal Stage",
            "Celiac Disease": "Celiac Disease",
            "Hypoglynemic Events": "Hypoglynemic Events",
            "Healthy": "Healthy",
            "Underweight": "Underweight",
            "Overweight": "Overweight",
            "Obesity": "Obesity",
            "Pathway": "Pathway",
            "Total Enrolled": "Total Enrolled",
            "Count ": "Count ",
            "Percentage": "Percentage",
            "Referred For Further Investigation": "Referred For Further Investigation",
            "Not Referred": "Not Referred",
            "Diagnosed ": "Diagnosed ",
            "Not Diagnosed ": "Not Diagnosed ",
            "On Treatment/ Medical Therapy": "On Treatment/ Medical Therapy",
            "Medical Therapy Not Initiated ": "Medical Therapy Not Initiated ",
            "Cured ": "Cured ",
            "Not Cured ": "Not Cured ",
            "Alerts": "Alerts",
            "All": "All",
            "All Follow Alert": "All Follow Alert",
            "Days": "Days",
            "Details": "Details",
            "Follow Up Alert": "Follow Up Alert",
          "Total people enrolled": "Total people enrolled",
          "Total T1Ds patient on treatment": "Total T1Ds patient on treatment",
          "Total T1D Inactive patient ": "Total T1D Inactive patient ",
          "Distribution Of T1D Patients By Gender": "Distribution Of T1D Patients By Gender",
          "Distribution Of T1D Patients By Age group": "Distribution Of T1D Patients By Age group",
          "BMI value distribution": "BMI value distribution",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled",
          "Total Patients With Co-Morbidities": "Total Patients With Co-Morbidities",
          "Complication Reporting Rate": "Complication Reporting Rate",
          "Home": "Home",
          "Pathway": "Pathway",
          "Linelist": "Line list",
          "Alerts": "Alerts",
          "Select filter": "Select filter",
          "Dashboard": "Dashboard",
          "Guinea": "Guinea",
          "Data upload": "Data upload",
          "Data Export": "Data Export",
          "Data management": "Data management",
          "User management": "User management",
          "Facility management": "Facility management",
          "Activated clients": "Activated clients",
          "Deactivated clients": "Deactivated clients",
          "Search": "Search",
          "Go to page": "Go to page",
          "Page": "Page",
          "Of": "Of",
          "Cases": "Cases",
          "Show": "Show",
          "UIC": "UIC",
          "Name": "Name",
          "Age": "Age",
          "Gender": "Gender",
          "Address": "Address",
          "Deactivate": "Deactivate",
          "Logout": "Logout"
      }
  },
  "es": {
      "translation": {
            "Data Management": "Gestión de datos",
            "Select Filter": "Seleccionar filtro",
            "Select ": "Seleccionar",
            "Apply": "Aplicar",
            "Reset": "Reiniciar",
            "Activated Clients": "Clientes activados",
            "Deactivated Clients": "Clientes desactivados",
            "Search": "Buscar",
            "Cases": "Casos",
            "Page of": "Página de",
            "Go to page": "ir a la pagina",
            "Show": "Espectáculo",
            "Name": "Nombre",
            "Age": "Edad",
            "Gender": "Género",
            "Address": "DIRECCIÓN",
            "Deacitivate": "Desactivar",
            "Client status has been set to inactive": "El estado del cliente se ha establecido en inactivo",
            "Close": "Cerca",
            "Activate": "Activar",
            "Client status has been set to activate": "El estado del cliente se ha configurado para activar",
            "Data Upload": "Carga de datos",
            "Data Export": "exportación de datos",
            "Choose File": "Elija el archivo",
            "No file chosen": "Ningún archivo elegido",
            "Download Template": "Descargar plantilla",
            "Upload": "Subir",
            "Success": "Éxito",
            "File uploaded sucessfully": "Archivo subido exitosamente",
            "Data Upload Logs": "Registros de carga de datos",
            "Uploaded by": "subido por",
            "Total Entries": "Entradas totales",
            "Valid": "Válido",
            "Invalid": "Inválido",
            "Upload Date": "Fecha de carga",
            "Response File": "Archivo de respuesta",
            "User Management": "Gestión de usuarios",
            "First Name": "Nombre de pila",
            "First name is required": "Se requiere el primer nombre",
            "Last Name": "Apellido",
            "Last name is required": "Se requiere apellido",
            "Email": "Correo electrónico",
            "Phone Number": "Número de teléfono",
            "Status": "Estado",
            "Active": "Activo",
            " Inactive": "Inactivo",
            "Edit": "Editar",
            "Add User": "Agregar usuario",
            "Edit User": "Editar usuario",
            "Username": "Nombre de usuario",
            "Username is required": "Se requiere nombre de usuario",
            "Mobile Number": "Número de teléfono móvil",
            "Minimum length 10": "Longitud mínima 10",
            "Role": "Role",
            "Role is required": "Se requiere rol",
            "Data Capture Unit": "Unidad de captura de datos",
            "Facility User": "Usuario de la instalación",
            "Healthworker": "Trabajador de la salud",
            "Operator": "Operador",
            "Patient Role": "Papel del paciente",
            "ReadOnlyUser": "Usuario de solo lectura",
            "Superuser": "Superusuario",
            "Email Address": "Dirección de correo electrónico",
            "Invalid email": "Email inválido",
            "Password": "Contraseña",
            "Password is required": "se requiere contraseña",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "La contraseña debe contener al menos 1 minúscula, 1 mayúscula, 1 número y 1 carácter de símbolo.",
            "Please include an '@' in the email address": "Por favor incluya una '@' en la dirección de correo electrónico",
            "Add": "Agregar",
            "Update": "Actualizar",
            "Facility Management": "Gestión de instalaciones",
            "Create New Facility": "Crear nueva instalación",
            "New Facility": "Nueva instalación",
            "Add Facility": "Agregar instalación",
            "Facility Code": "Código de instalación",
            "Facility Name": "Nombre de la instalación",
            "Facility name is required": "El nombre de la instalación es obligatorio.",
            "Facility Address": "Dirección de la instalación",
            "Facility address is required": "Se requiere la dirección de la instalación",
            "Facility Email": "Correo electrónico de la instalación",
            "Email is required": "correo electronico es requerido",
            "Facility Phone Number": "Número de teléfono de la instalación",
            "Phone number must be exactly 10 digits.": "El número de teléfono debe tener exactamente 10 dígitos.",
            "Select Province": "Seleccionar Provincia",
            "Select District": "Seleccionar Distrito",
            "Create New Organization": "Crear nueva organización",
            "Add Organization": "Agregar organización",
            "Organization Name": "Nombre de la Organización",
            "Organization name is required": "El nombre de la organización es obligatorio.",
            "Organization Parent": "Organización principal",
            "Select Country": "Seleccionar país",
            "Error": "Error",
            "Someting went wrong.\n": "Algo salió mal.",
            "Edit Facility": "Editar instalación",
            "Logout": "Cerrar sesión",
            "Organization Units": "Unidades organizativas",
            "Select": "Seleccionar",
            "Apply ": "Aplicar",
            "Total number of unique people got registered on the platform.": "Número total de personas únicas registradas en la plataforma.",
            "Total number of T1Ds patients on active treatment": "Número total de pacientes con diabetes tipo 1 en tratamiento activo",
            "Total number of T1Ds patients who are not active on treatment.": "Número total de pacientes con diabetes tipo 1 que no están activos en tratamiento.",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "Pacientes diabéticos cuyo último valor registrado de HBA1C es menor o igual a 7",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "Pacientes diabéticos cuyo último valor registrado de HBA1C es mayor o igual a 8",
            "Chart context menu": "Menú contextual del gráfico",
            "View in full screen": "Ver en pantalla completa",
            "Print chart": "Tabla de impresión",
            "Download PNG image": "Descargar imagen PNG",
            "Download JPEG image": "Descargar imagen JPEG",
            "Download PDF document": "Descargar documento PDF",
            "Download SVG vector image": "Descargar imagen vectorial SVG",
            "Download CSV": "Descargar CSV",
            "Download XLS": "Descargar XLS",
            "View data table": "Ver tabla de datos",
            "Total Number Patients- Male": "Número total de pacientes: hombres",
            "Total Number Patients- Female": "Número total de pacientes: mujeres",
            "Total Number Patients- Other": "Número total de pacientes: otros",
            "To": "A",
            "Above": "Arriba",
            "Below": "Abajo",
            "Smoking": "De fumar",
            "Mental Health Disorder": "Trastorno de salud mental",
            "Pubertal Stage": "Etapa puberal",
            "Celiac Disease": "Enfermedad celíaca",
            "Hypoglynemic Events": "Eventos hipoglinémicos",
            "Healthy": "Saludable",
            "Underweight": "Bajo peso",
            "Overweight": "Exceso de peso",
            "Obesity": "Obesidad",
            "Pathway": "Ruta",
            "Total Enrolled": "Total matriculados",
            "Count ": "Contar",
            "Percentage": "Porcentaje",
            "Referred For Further Investigation": "Remitido para mayor investigación",
            "Not Referred": "No referido",
            "Diagnosed ": "Diagnosticado",
            "Not Diagnosed ": "No diagnosticado",
            "On Treatment/ Medical Therapy": "Sobre el tratamiento/terapia médica",
            "Medical Therapy Not Initiated ": "Terapia médica no iniciada",
            "Cured ": "Curado",
            "Not Cured ": "No curado",
            "Alerts": "Alertas",
            "All": "Todo",
            "All Follow Alert": "Todos siguen alerta",
            "Days": "Días",
            "Details": "Detalles",
            "Follow Up Alert": "Alerta de seguimiento",
          "Total people enrolled": "Total de personas inscritas",
          "Total T1Ds patient on treatment": "Total de pacientes con diabetes tipo 1 en tratamiento",
          "Total T1D Inactive patient ": "Total DT1 Paciente inactivo",
          "Distribution Of T1D Patients By Gender": "Distribución de pacientes con diabetes tipo 1 por género",
          "Distribution Of T1D Patients By Age group": "Distribución de pacientes con diabetes tipo 1 por grupo de edad",
          "BMI value distribution": "Distribución del valor del IMC",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Estado de control de diabetes basado en HbA1C\n- Diabetes controlada\n- Diabetes no controlada",
          "Total Patients With Co-Morbidities": "Total de pacientes con comorbilidades",
          "Complication Reporting Rate": "Tasa de notificación de complicaciones",
          "Home": "Hogar",
          "Pathway": "Ruta",
          "Linelist": "Lista de líneas",
          "Alerts": "Alertas",
          "Select filter": "Seleccionar filtro",
          "Dashboard": "Panel",
          "Guinea": "Guinea",
          "Data upload": "Carga de datos",
          "Data management": "Gestión de datos",
          "User management": "Gestión de usuarios",
          "Facility management": "Gestión de instalaciones",
          "Activated clients": "Clientes activados",
          "Deactivated clients": "Clientes desactivados",
          "Search": "Buscar",
          "Go to page": "ir a la pagina",
          "Page": "Página",
          "Of": "De",
          "Cases": "Casos",
          "Show": "Espectáculo",
          "UIC": "UIC",
          "Name": "Nombre",
          "Age": "Edad",
          "Gender": "Género",
          "Address": "DIRECCIÓN",
          "Deactivate": "Desactivar",
          "Logout": "Cerrar sesión",
          "Organisation":"Organisation"
      }
  },
  "fr": {
      "translation": {
            "Data Management ": "Gestion de données",
            "Select Filter": "Sélectionnez un filtre",
            "Select ": "Sélectionner",
            "Apply": "Appliquer",
            "Reset": "Réinitialiser",
            "Activated Clients": "Clients activés",
            "Deactivated Clients": "Clients désactivés",
            "Search": "Recherche",
            "Cases": "Cas",
            "Page of": "Page de",
            "Go to page": "Aller à la page",
            "Show": "Montrer",
            "Name": "Nom",
            "Age": "Âge",
            "Gender": "Genre",
            "Address": "Adresse",
            "Deacitivate": "Désactiver",
            "Client status has been set to inactive": "Le statut du client a été défini sur inactif",
            "Close": "Fermer",
            "Activate": "Activer",
            "Client status has been set to activate": "Le statut du client a été défini pour être activé",
            "Data Upload": "Téléchargement de données",
            "Data Export": "Exportation de données",
            "Choose File": "Choisir le fichier",
            "No file chosen": "Aucun fichier choisi",
            "Download Template": "Télécharger le modèle",
            "Upload": "Télécharger",
            "Success": "Succès",
            "File uploaded sucessfully": "Fichier téléchargé avec succès",
            "Data Upload Logs": "Journaux de téléchargement de données",
            "Uploaded by": "telechargé par",
            "Total Entries": "Entrées totales",
            "Valid": "Valide",
            "Invalid": "Invalide",
            "Upload Date": "Date de dépôt",
            "Response File": "Fichier de réponses",
            "User Management": "Gestion des utilisateurs",
            "First Name": "Prénom",
            "First name is required": "Le prénom est requis",
            "Last Name": "Nom de famille",
            "Last name is required": "Le nom de famille est obligatoire",
            "Email": "E-mail",
            "Phone Number": "Numéro de téléphone",
            "Status": "Statut",
            "Active": "Actif",
            " Inactive": "Inactif",
            "Edit": "Modifier",
            "Add User": "Ajouter un utilisateur",
            "Edit User":"Modifier l'utilisateur",
            "Username": "Nom d'utilisateur",
            "Username is required": "Nom d'utilisateur est nécessaire",
            "Mobile Number": "Numéro de portable",
            "Minimum length 10": "Longueur minimale 10",
            "Role": "Rôle",
            "Role is required": "Le rôle est requis",
            "Data Capture Unit": "Unité de capture de données",
            "Facility User": "Utilisateur de l'installation",
            "Healthworker": "Agent de santé",
            "Operator": "Opérateur",
            "Patient Role": "Rôle du patient",
            "ReadOnlyUser": "Utilisateur en lecture seule",
            "Superuser": "Superutilisateur",
            "Email Address": "Adresse e-mail",
            "Invalid email": "Email invalide",
            "Password": "Mot de passe",
            "Password is required": "Mot de passe requis",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "Le mot de passe doit contenir au moins 1 minuscule, 1 majuscule, 1 chiffre et 1 caractère symbole",
            "Please include an '@' in the email address": "Veuillez inclure un « @ » dans l'adresse e-mail",
            "Add": "Ajouter",
            "Update": "Mise à jour",
            "Facility Management": "Gestion des installations",
            "Create New Facility": "Créer une nouvelle installation",
            "New Facility": "Nouvelle installation",
            "Add Facility": "Ajouter une installation",
            "Facility Code": "Code de l'établissement",
            "Facility Name": "Nom de l'installation",
            "Facility name is required": "Le nom de l'établissement est requis",
            "Facility Address": "Adresse de l'établissement",
            "Facility address is required": "L'adresse de l'établissement est requise",
            "Facility Email": "E-mail de l'établissement",
            "Email is required": "L'e-mail est requis",
            "Facility Phone Number": "Numéro de téléphone de l'établissement",
            "Phone number must be exactly 10 digits.": "Le numéro de téléphone doit comporter exactement 10 chiffres.",
            "Select Province": "Sélectionnez une province",
            "Select District": "Sélectionnez le quartier",
            "Create New Organization": "Créer une nouvelle organisation",
            "Organisation": "Organisation",
            "Add Organization": "Ajouter une organisation",
            "Organization Name": "nom de l'organisation",
            "Organization name is required": "Le nom de l'organisation est requis",
            "Organization Parent": "Organisation parente",
            "Select Country": "Choisissez le pays",
            "Error": "Erreur",
            "Someting went wrong.\n": "Quelque chose s'est mal passé.",
            "Edit Facility": "Modifier l'établissement",
            "Logout": "Se déconnecter",
            "Organization Units": "Unités organisationnelles",
            "Select": "Sélectionner",
            "Apply ": "Appliquer",
            "Total number of unique people got registered on the platform.": "Nombre total de personnes uniques inscrites sur la plateforme.",
            "Total number of T1Ds patients on active treatment": "Nombre total de patients atteints de DT1 sous traitement actif",
            "Total number of T1Ds patients who are not active on treatment.": "Nombre total de patients atteints de DT1 qui ne suivent pas de traitement actif.",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "Patients diabétiques dont la dernière valeur HBA1C enregistrée est inférieure ou égale à 7",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "Patients diabétiques dont la dernière valeur HBA1C enregistrée est supérieure ou égale à 8",
            "Chart context menu": "Menu contextuel du graphique",
            "View in full screen": "Afficher en plein écran",
            "Print chart": "Imprimer le graphique",
            "Download PNG image": "Télécharger l'image PNG",
            "Download JPEG image": "Télécharger l'image JPEG",
            "Download PDF document": "Télécharger le document PDF",
            "Download SVG vector image": "Télécharger l'image vectorielle SVG",
            "Download CSV": "Télécharger CSV",
            "Download XLS": "Télécharger XLS",
            "View data table": "Afficher le tableau de données",
            "Total Number Patients- Male": "Nombre total de patients - hommes",
            "Total Number Patients- Female": "Nombre total de patients - Femmes",
            "Total Number Patients- Other": "Nombre total de patients - Autres",
            "To": "À",
            "Above": "Au-dessus de",
            "Below": "Ci-dessous",
            "Smoking": "Fumeur",
            "Mental Health Disorder": "Trouble de santé mentale",
            "Pubertal Stage": "Stade pubertaire",
            "Celiac Disease": "Maladie coeliaque",
            "Hypoglynemic Events": "Événements hypoglynémiques",
            "Healthy": "En bonne santé",
            "Underweight": "Insuffisance pondérale",
            "Overweight": "en surpoids",
            "Obesity": "Obésité",
            "Pathway": "Sentier",
            "Total Enrolled": "Total inscrit",
            "Count ": "Compter",
            "Percentage": "Pourcentage",
            "Referred For Further Investigation": "Renvoyé pour une enquête plus approfondie",
            "Not Referred": "Non référencé",
            "Diagnosed ": "Diagnostiqué",
            "Not Diagnosed ": "Non diagnostiqué",
            "On Treatment/ Medical Therapy": "En traitement/thérapie médicale",
            "Medical Therapy Not Initiated ": "Thérapie médicale non initiée",
            "Cured ": "Guéri",
            "Not Cured ": "Non guéri",
            "Alerts": "Alertes",
            "All": "Tous",
            "All Follow Alert": "Alerte de suivi de tous",
            "Days": "Jours",
            "Details": "Détails",
            "Follow Up Alert": "Alerte de suivi",
          "Total people enrolled": "Nombre total de personnes inscrites",
          "Total T1Ds patient on treatment": "Total des patients atteints de DT1 sous traitement",
          "Total T1D Inactive patient ": "Total DT1 Patient inactif",
          "Distribution Of T1D Patients By Gender": "Répartition des patients DT1 par sexe",
          "Distribution Of T1D Patients By Age group": "Répartition des patients atteints de DT1 par groupe d'âge",
          "BMI value distribution": "Répartition de la valeur de l'IMC",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "Statut de contrôle du diabète basé sur l'HbA1C\n- Diabète contrôlé\n- Diabète incontrôlé",
          "Total Patients With Co-Morbidities": "Nombre total de patients présentant des comorbidités",
          "Complication Reporting Rate": "Taux de rapports de complications",
          "Home": "Maison",
          "Pathway": "Sentier",
          "Linelist": "Liste de lignes",
          "Alerts": "Alertes",
          "Select filter": "Sélectionnez le filtre",
          "Dashboard": "Tableau de bord",
          "Guinea": "Guinée",
          "Data upload": "Téléchargement de données",
          "Data management": "Gestion de données",
          "User management": "Gestion des utilisateurs",
          "Facility management": "Gestion des installations",
          "Activated clients": "Clients activés",
          "Deactivated clients": "Clients désactivés",
          "Search": "Recherche",
          "Go to page": "Aller à la page",
          "Page": "Page",
          "Of": "De",
          "Cases": "Cas",
          "Show": "Montrer",
          "UIC": "CUI",
          "Name": "Nom",
          "Age": "Âge",
          "Gender": "Genre",
          "Address": "Adresse",
          "Deactivate": "Désactiver",
          "Logout": "Se déconnecter"
      }
  },
  "hi": {
      "translation": {
            "Organisation":"संगठन",
            "Data Management": "डेटा प्रबंधन",
            "Select Filter": "फ़िल्टर चुनें",
            "Select ": "चुनना",
            "Apply": "आवेदन करना",
            "Reset": "रीसेट",
            "Activated Clients": "सक्रिय ग्राहक",
            "Deactivated Clients": "निष्क्रिय ग्राहक",
            "Search": "खोज",
            "Cases": "मामलों",
            "Page of": "पृष्ठ का",
            "Go to page": "पृष्ठ पर जाओ",
            "Show": "दिखाओ",
            "Name": "नाम",
            "Age": "आयु",
            "Gender": "लिंग",
            "Address": "पता",
            "Deacitivate": "निष्क्रियता",
            "Client status has been set to inactive": "क्लाइंट की स्थिति को निष्क्रिय कर दिया गया है",
            "Close": "बंद करना",
            "Activate": "सक्रिय",
            "Client status has been set to activate": "क्लाइंट स्थिति को सक्रिय करने के लिए सेट कर दिया गया है",
            "Data Upload": "डेटा अपलोड",
            "Data Export": "डेटा निर्यात",
            "Choose File": "फाइलें चुनें",
            "No file chosen": "कोई फ़ाइल चुना नही",
            "Download Template": "टेम्पलेट डाउनलोड करें",
            "Upload": "डालना",
            "Success": "सफलता",
            "File uploaded sucessfully": "फ़ाइल सफलतापूर्वक अपलोड हो गई",
            "Data Upload Logs": "डेटा अपलोड लॉग",
            "Uploaded by": "द्वारा डाली गई",
            "Total Entries": "कुल प्रविष्टियां",
            "Valid": "वैध",
            "Invalid": "अमान्य",
            "Upload Date": "बार डालने की तारिक",
            "Response File": "प्रतिक्रिया फ़ाइल",
            "User Management": "प्रयोक्ता प्रबंधन",
            "First Name": "पहला नाम",
            "First name is required": "पहला नाम आवश्यक है",
            "Last Name": "उपनाम",
            "Last name is required": "अंतिम नाम आवश्यक है",
            "Email": "ईमेल",
            "Phone Number": "फ़ोन नंबर",
            "Status": "स्थिति",
            "Active": "सक्रिय",
            " Inactive": "निष्क्रिय",
            "Edit": "संपादन करना",
            "Add User": "उपयोगकर्ता जोड़ें",
            "Edit User": "उपयोगकर्ता को संपादित करो",
            "Username": "उपयोगकर्ता नाम",
            "Username is required": "उपयोगकर्ता नाम आवश्यक है",
            "Mobile Number": "मोबाइल नंबर",
            "Minimum length 10": "न्यूनतम लंबाई 10",
            "Role": "भूमिका",
            "Role is required": "भूमिका आवश्यक है",
            "Data Capture Unit": "डेटा कैप्चर यूनिट",
            "Facility User": "सुविधा उपयोगकर्ता",
            "Healthworker": "स्वास्थ्य कार्यकर्ता",
            "Operator": "ऑपरेटर",
            "Patient Role": "रोगी की भूमिका",
            "ReadOnlyUser": "केवल पढ़ने योग्य उपयोगकर्ता",
            "Superuser": "सुपर उपयोगकर्ता",
            "Email Address": "मेल पता",
            "Invalid email": "अमान्य ईमेल",
            "Password": "पासवर्ड",
            "Password is required": "पासवर्ड की आवश्यकता है",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "पासवर्ड में कम से कम 1 लोअरकेस, 1 अपरकेस, 1 नंबर और 1 सिंबल कैरेक्टर होना चाहिए",
            "Please include an '@' in the email address": "कृपया ईमेल पते में '@' शामिल करें",
            "Add": "जोड़ना",
            "Update": "अद्यतन",
            "Facility Management": "सुविधा प्रबंधन",
            "Create New Facility": "नई सुविधा बनाएं",
            "New Facility": "नई सुविधा",
            "Add Facility": "सुविधा जोड़ें",
            "Facility Code": "सुविधा कोड",
            "Facility Name": "सुविधा का नाम",
            "Facility name is required": "सुविधा का नाम आवश्यक है",
            "Facility Address": "सुविधा का पता",
            "Facility address is required": "सुविधा पता आवश्यक है",
            "Facility Email": "सुविधा ईमेल",
            "Email is required": "ईमेल की जरूरत है",
            "Facility Phone Number": "सुविधा फ़ोन नंबर",
            "Phone number must be exactly 10 digits.": "फ़ोन नंबर बिल्कुल 10 अंकों का होना चाहिए.",
            "Select Province": "प्रांत चुनें",
            "Select District": "जिला चुनें",
            "Create New Organization": "नया संगठन बनाएं",
            "Add Organization": "संगठन जोड़ें",
            "Organization Name": "संगठन का नाम",
            "Organization name is required": "संगठन का नाम आवश्यक है",
            "Organization Parent": "संगठन जनक",
            "Select Country": "देश चुनें",
            "Error": "गलती",
            "Someting went wrong.\n": "कुछ ग़लत हो गया.",
            "Edit Facility": "संपादन सुविधा",
            "Logout": "लॉग आउट",
            "Organization Units": "संगठन इकाइयाँ",
            "Select": "चुनना",
            "Apply ": "आवेदन करना",
            "Total number of unique people got registered on the platform.": "मंच पर कुल कितने अद्वितीय लोग पंजीकृत हुए।",
            "Total number of T1Ds patients on active treatment": "सक्रिय उपचार पर T1Ds रोगियों की कुल संख्या",
            "Total number of T1Ds patients who are not active on treatment.": "टी1डी रोगियों की कुल संख्या जो उपचार पर सक्रिय नहीं हैं।",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "मधुमेह के मरीज़ जिनका अंतिम HBA1C दर्ज किया गया मान 7 से कम या उसके बराबर है",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "मधुमेह के मरीज जिनका अंतिम HBA1C दर्ज मूल्य 8 से अधिक या उसके बराबर है",
            "Chart context menu": "चार्ट संदर्भ मेनू",
            "View in full screen": "पूर्ण स्क्रीन में देखें",
            "Print chart": "चार्ट प्रिंट करें",
            "Download PNG image": "PNG छवि डाउनलोड करें",
            "Download JPEG image": "JPEG छवि डाउनलोड करें",
            "Download PDF document": "पीडीएफ दस्तावेज़ डाउनलोड करें",
            "Download SVG vector image": "SVG वेक्टर छवि डाउनलोड करें",
            "Download CSV": "सीएसवी डाउनलोड करें",
            "Download XLS": "XLS डाउनलोड करें",
            "View data table": "डेटा तालिका देखें",
            "Total Number Patients- Male": "कुल मरीज़ों की संख्या- पुरुष",
            "Total Number Patients- Female": "कुल मरीज़ों की संख्या- महिला",
            "Total Number Patients- Other": "कुल मरीज़ों की संख्या- अन्य",
            "To": "को",
            "Above": "ऊपर",
            "Below": "नीचे",
            "Smoking": "धूम्रपान",
            "Mental Health Disorder": "मानसिक स्वास्थ्य विकार",
            "Pubertal Stage": "यौवन अवस्था",
            "Celiac Disease": "सीलिएक रोग",
            "Hypoglynemic Events": "हाइपोग्लाइनेमिक घटनाएँ",
            "Healthy": "स्वस्थ",
            "Underweight": "वजन",
            "Overweight": "अधिक वजन",
            "Obesity": "मोटापा",
            "Pathway": "मार्ग",
            "Total Enrolled": "कुल नामांकित",
            "Count ": "गिनती करना",
            "Percentage": "को PERCENTAGE",
            "Referred For Further Investigation": "आगे की जांच के लिए भेजा गया",
            "Not Referred": "संदर्भित नहीं",
            "Diagnosed ": "निदान",
            "Not Diagnosed ": "निदान नहीं हुआ",
            "On Treatment/ Medical Therapy": "उपचार/चिकित्सा चिकित्सा पर",
            "Medical Therapy Not Initiated ": "चिकित्सा उपचार शुरू नहीं किया गया",
            "Cured ": "ठीक",
            "Not Cured ": "ठीक नहीं हुआ",
            "Alerts": "अलर्ट",
            "All": "सभी",
            "All Follow Alert": "सभी फ़ॉलो अलर्ट",
            "Days": "दिन",
            "Details": "विवरण",
            "Follow Up Alert": "अनुवर्ती चेतावनी",
          "Total people enrolled": "कुल नामांकित लोग",
          "Total T1Ds patient on treatment": "उपचाराधीन कुल टी1डी रोगी",
          "Total T1D Inactive patient ": "कुल T1D निष्क्रिय रोगी",
          "Distribution Of T1D Patients By Gender": "लिंग के आधार पर टी1डी रोगियों का वितरण",
          "Distribution Of T1D Patients By Age group": "आयु समूह के अनुसार टी1डी रोगियों का वितरण",
          "BMI value distribution": "बीएमआई मूल्य वितरण",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "HbA1C पर आधारित मधुमेह नियंत्रण स्थिति\n-मधुमेह नियंत्रित\n- मधुमेह अनियंत्रित",
          "Total Patients With Co-Morbidities": "सह-रुग्णता वाले कुल मरीज़",
          "Complication Reporting Rate": "जटिलता रिपोर्टिंग दर",
          "Home": "घर",
          "Pathway": "मार्ग",
          "Linelist": "लाइनलिस्ट",
          "Alerts": "अलर्ट",
          "Select filter": "फ़िल्टर चुनें",
          "Dashboard": "डैशबोर्ड",
          "Guinea": "गिनी",
          "Data upload": "डेटा अपलोड",
          "Data management": "डेटा प्रबंधन",
          "User management": "प्रयोक्ता प्रबंधन",
          "Facility management": "सुविधा प्रबंधन",
          "Activated clients": "सक्रिय ग्राहक",
          "Deactivated clients": "निष्क्रिय ग्राहक",
          "Search": "खोज",
          "Go to page": "पृष्ठ पर जाओ",
          "Page": "पृष्ठ",
          "Of": "का",
          "Cases": "मामलों",
          "Show": "दिखाओ",
          "UIC": "यूआईसी",
          "Name": "नाम",
          "Age": "आयु",
          "Gender": "लिंग",
          "Address": "पता",
          "Deactivate": "निष्क्रिय करें",
          "Logout": "लॉग आउट"
      }
  },
  "ru": {
      "translation": {
            "Organisation":"организация",
            "Data Management": "Управление данными",
            "Select Filter": "Выберите Фильтр",
            "Select ": "Выбирать",
            "Apply": "Применять",
            "Reset": "Перезагрузить",
            "Activated Clients": "Активированные клиенты",
            "Deactivated Clients": "Деактивированные клиенты",
            "Search": "Поиск",
            "Cases": "Случаи",
            "Page of": "Страница из",
            "Go to page": "Перейти на страницу",
            "Show": "Показывать",
            "Name": "Имя",
            "Age": "Возраст",
            "Gender": "Пол",
            "Address": "Адрес",
            "Deacitivate": "Деактивировать",
            "Client status has been set to inactive": "Статус клиента установлен на неактивный",
            "Close": "Закрывать",
            "Activate": "Активировать",
            "Client status has been set to activate": "Статус клиента установлен на активацию",
            "Data Upload": "Загрузка данных",
            "Data Export": "экспорт данных",
            "Choose File": "Выберите файл",
            "No file chosen": "Файл не выбран",
            "Download Template": "Скачать шаблон",
            "Upload": "Загрузить",
            "Success": "Успех",
            "File uploaded sucessfully": "Файл успешно загружен",
            "Data Upload Logs": "Журналы загрузки данных",
            "Uploaded by": "Загружено пользователем",
            "Total Entries": "Всего записей",
            "Valid": "Действительный",
            "Invalid": "Неверный",
            "Upload Date": "Дата загрузки",
            "Response File": "Файл ответов",
            "User Management": "Управление пользователями",
            "First Name": "Имя",
            "First name is required": "Требуется имя",
            "Last Name": "Фамилия",
            "Last name is required": "Требуется фамилия",
            "Email": "Электронная почта",
            "Phone Number": "Номер телефона",
            "Status": "Положение дел",
            "Active": "Активный",
            " Inactive": "Неактивный",
            "Edit": "Редактировать",
            "Add User": "Добавить пользователя",
            "Edit User":"редактировать пользователя",
            "Username": "Имя пользователя",
            "Username is required": "Имя пользователя требуется",
            "Mobile Number": "Номер мобильного телефона",
            "Minimum length 10": "Минимальная длина 10",
            "Role": "Роль",
            "Role is required": "Требуется роль",
            "Data Capture Unit": "Блок сбора данных",
            "Facility User": "Пользователь объекта",
            "Healthworker": "Медработник",
            "Operator": "Оператор",
            "Patient Role": "Роль пациента",
            "ReadOnlyUser": "ReadOnlyUser",
            "Superuser": "Суперпользователь",
            "Email Address": "Адрес электронной почты",
            "Invalid email": "Неверный адрес электронной почты",
            "Password": "Пароль",
            "Password is required": "Необходим пароль",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "Пароль должен содержать как минимум 1 строчную, 1 заглавную, 1 цифру и 1 символ.",
            "Please include an '@' in the email address": "Пожалуйста, включите «@» в адрес электронной почты",
            "Add": "Добавлять",
            "Update": "Обновлять",
            "Facility Management": "Управление объектом",
            "Create New Facility": "Создать новый объект",
            "New Facility": "Новый объект",
            "Add Facility": "Добавить объект",
            "Facility Code": "Код объекта",
            "Facility Name": "Название объекта",
            "Facility name is required": "Укажите название объекта.",
            "Facility Address": "Адрес объекта",
            "Facility address is required": "Укажите адрес объекта.",
            "Facility Email": "Электронная почта объекта",
            "Email is required": "Требуется электронная почта",
            "Facility Phone Number": "Номер телефона учреждения",
            "Phone number must be exactly 10 digits.": "Номер телефона должен состоять ровно из 10 цифр.",
            "Select Province": "Выберите провинцию",
            "Select District": "Выберите район",
            "Create New Organization": "Создать новую организацию",
            "Add Organization": "Добавить организацию",
            "Organization Name": "Название организации",
            "Organization name is required": "Укажите название организации.",
            "Organization Parent": "Родительская организация",
            "Select Country": "Выберите страну",
            "Error": "Ошибка",
            "Someting went wrong.\n": "Что-то пошло не так.",
            "Edit Facility": "Редактировать объект",
            "Logout": "Выйти",
            "Organization Units": "Организационные подразделения",
            "Select": "Выбирать",
            "Apply ": "Применять",
            "Total number of unique people got registered on the platform.": "Общее количество уникальных людей, зарегистрированных на платформе.",
            "Total number of T1Ds patients on active treatment": "Общее количество пациентов с СД1, находящихся на активном лечении",
            "Total number of T1Ds patients who are not active on treatment.": "Общее количество пациентов с СД1, не получающих активного лечения.",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "Пациенты с диабетом, у которых последнее зарегистрированное значение HBA1C меньше или равно 7.",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "Пациенты с диабетом, у которых последнее зарегистрированное значение HBA1C больше или равно 8.",
            "Chart context menu": "Контекстное меню диаграммы",
            "View in full screen": "Посмотреть в полноэкранном режиме",
            "Print chart": "Распечатать диаграмму",
            "Download PNG image": "Скачать PNG картинку",
            "Download JPEG image": "Скачать изображение JPEG",
            "Download PDF document": "Скачать PDF-документ",
            "Download SVG vector image": "Скачать векторное изображение SVG",
            "Download CSV": "Скачать CSV-файл",
            "Download XLS": "Скачать XLS",
            "View data table": "Посмотреть таблицу данных",
            "Total Number Patients- Male": "Общее количество пациентов – мужчины",
            "Total Number Patients- Female": "Общее количество пациентов – женщины",
            "Total Number Patients- Other": "Общее число пациентов – другое",
            "To": "К",
            "Above": "Выше",
            "Below": "Ниже",
            "Smoking": "Курение",
            "Mental Health Disorder": "Расстройство психического здоровья",
            "Pubertal Stage": "Пубертатная стадия",
            "Celiac Disease": "Целиакия",
            "Hypoglynemic Events": "Гипоглинемические явления",
            "Healthy": "Здоровый",
            "Underweight": "Недостаток веса",
            "Overweight": "Избыточный вес",
            "Obesity": "Ожирение",
            "Pathway": "Путь",
            "Total Enrolled": "Всего зачислено",
            "Count ": "Считать",
            "Percentage": "Процент",
            "Referred For Further Investigation": "Направлено на дальнейшее расследование",
            "Not Referred": "Не направлено",
            "Diagnosed ": "Диагностирован",
            "Not Diagnosed ": "Не диагностирован",
            "On Treatment/ Medical Therapy": "О лечении/медицинской терапии",
            "Medical Therapy Not Initiated ": "Медикаментозная терапия не начата",
            "Cured ": "Вылеченный",
            "Not Cured ": "Не вылечено",
            "Alerts": "Оповещения",
            "All": "Все",
            "All Follow Alert": "Все оповещения о подписке",
            "Days": "Дни",
            "Details": "Подробности",
            "Follow Up Alert": "Следующее оповещение",
          "Total people enrolled": "Всего зачислено людей",
          "Total T1Ds patient on treatment": "Всего пациентов с СД1, находящихся на лечении",
          "Total T1D Inactive patient ": "Всего неактивных пациентов с СД1",
          "Distribution Of T1D Patients By Gender": "Распределение пациентов с СД1 по полу",
          "Distribution Of T1D Patients By Age group": "Распределение пациентов с СД1 по возрастным группам",
          "BMI value distribution": "Распределение значений ИМТ",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "«Статус контроля диабета на основе HbA1C\n- Диабет под контролем\n- Неконтролируемый диабет»",
          "Total Patients With Co-Morbidities": "Всего пациентов с сопутствующими заболеваниями",
          "Complication Reporting Rate": "Частота сообщений об осложнениях",
          "Home": "Дом",
          "Pathway": "Путь",
          "Linelist": "Список строк",
          "Alerts": "Оповещения",
          "Select filter": "Выбрать фильтр",
          "Dashboard": "Панель приборов",
          "Guinea": "Гвинея",
          "Data upload": "Загрузка данных",
          "Data management": "Управление данными",
          "User management": "Управление пользователями",
          "Facility management": "Управление объектом",
          "Activated clients": "Активированные клиенты",
          "Deactivated clients": "Деактивированные клиенты",
          "Search": "Поиск",
          "Go to page": "Перейти на страницу",
          "Page": "Страница",
          "Of": "Из",
          "Cases": "Случаи",
          "Show": "Показывать",
          "UIC": "МСЖД",
          "Name": "Имя",
          "Age": "Возраст",
          "Gender": "Пол",
          "Address": "Адрес",
          "Deactivate": "Деактивировать",
          "Logout": "Выйти"
      }
  },
  "zh": {
      "translation": {
            "Organisation":"组织",
            "Data Management": "数据管理",
            "Select Filter": "选择过滤器",
            "Select ": "选择",
            "Apply": "申请",
            "Reset": "重置",
            "Activated Clients": "激活客户",
            "Deactivated Clients": "停用的客户端",
            "Search": "搜索",
            "Cases": "案例",
            "Page of": "页数",
            "Go to page": "转到页面",
            "Show": "展示",
            "Name": "姓名",
            "Age": "年龄",
            "Gender": "性别",
            "Address": "地址",
            "Deacitivate": "停用",
            "Client status has been set to inactive": "客户端状态已设置为非活动状态",
            "Close": "关闭",
            "Activate": "启用",
            "Client status has been set to activate": "客户端状态已设置为激活",
            "Data Upload": "数据上传",
            "Data Export": "数据导出",
            "Choose File": "选择文件",
            "No file chosen": "没有选中任何文件",
            "Download Template": "下载模板",
            "Upload": "上传",
            "Success": "成功",
            "File uploaded sucessfully": "文件上传成功",
            "Data Upload Logs": "数据上传日志",
            "Uploaded by": "上传者：",
            "Total Entries": "参赛作品总数",
            "Valid": "有效的",
            "Invalid": "无效的",
            "Upload Date": "上传日期",
            "Response File": "响应文件",
            "User Management": "用户管理",
            "First Name": "名",
            "First name is required": "名字为必填项",
            "Last Name": "姓",
            "Last name is required": "姓氏为必填项",
            "Email": "电子邮件",
            "Phone Number": "电话号码",
            "Status": "地位",
            "Active": "积极的",
            " Inactive": "不活跃",
            "Edit": "编辑",
            "Add User": "添加用户",
            "Edit User": "编辑用户",
            "Username": "用户名",
            "Username is required": "用户名是必需的",
            "Mobile Number": "手机号码",
            "Minimum length 10": "最小长度 10",
            "Role": "角色",
            "Role is required": "角色为必填项",
            "Data Capture Unit": "数据采集单元",
            "Facility User": "设施使用者",
            "Healthworker": "保健员",
            "Operator": "操作员",
            "Patient Role": "患者角色",
            "ReadOnlyUser": "只读用户",
            "Superuser": "超级用户",
            "Email Address": "电子邮件地址",
            "Invalid email": "不合规电邮",
            "Password": "密码",
            "Password is required": "密码是必需的",
            "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 symbol character": "密码必须至少包含 1 个小写字母、1 个大写字母、1 个数字和 1 个符号字符",
            "Please include an '@' in the email address": "请在电子邮件地址中添加“@”",
            "Add": "添加",
            "Update": "更新",
            "Facility Management": "设施管理",
            "Create New Facility": "创建新设施",
            "New Facility": "新设施",
            "Add Facility": "添加设施",
            "Facility Code": "设施代码",
            "Facility Name": "设备名称",
            "Facility name is required": "设施名称为必填项",
            "Facility Address": "设施地址",
            "Facility address is required": "需要提供设施地址",
            "Facility Email": "设施电子邮件",
            "Email is required": "电子邮件为必填项",
            "Facility Phone Number": "设施电话号码",
            "Phone number must be exactly 10 digits.": "电话号码必须正好是 10 位数字。",
            "Select Province": "选择省份",
            "Select District": "选择地区",
            "Create New Organization": "创建新组织",
            "Add Organization": "添加组织",
            "Organization Name": "机构名称",
            "Organization name is required": "组织名称为必填项",
            "Organization Parent": "组织父级",
            "Select Country": "选择国家",
            "Error": "错误",
            "Someting went wrong.\n": "出了点问题。",
            "Edit Facility": "编辑设施",
            "Logout": "登出",
            "Organization Units": "组织单位",
            "Select": "选择",
            "Apply ": "申请",
            "Total number of unique people got registered on the platform.": "该平台上注册的唯一人数总数。",
            "Total number of T1Ds patients on active treatment": "接受积极治疗的 1 型糖尿病患者总数",
            "Total number of T1Ds patients who are not active on treatment.": "未积极接受治疗的 1 型糖尿病患者总数。",
            "Diabetic patients who's last HBA1C recorded value is less than or equal to 7": "糖尿病患者最后一次HBA1C记录值小于或等于7",
            "Diabetic patients who's last HBA1C recorded value is greater than or equal to 8": "糖尿病患者最后一次HBA1C记录值大于或等于8",
            "Chart context menu": "图表上下文菜单",
            "View in full screen": "全屏查看",
            "Print chart": "打印图表",
            "Download PNG image": "下载 PNG 图像",
            "Download JPEG image": "下载 JPEG 图像",
            "Download PDF document": "下载 PDF 文档",
            "Download SVG vector image": "下载 SVG 矢量图像",
            "Download CSV": "下载 CSV",
            "Download XLS": "下载 XLS",
            "View data table": "查看数据表",
            "Total Number Patients- Male": "患者总数 - 男性",
            "Total Number Patients- Female": "女性患者总数",
            "Total Number Patients- Other": "其他患者总数",
            "To": "到",
            "Above": "多于",
            "Below": "以下",
            "Smoking": "抽烟",
            "Mental Health Disorder": "精神健康障碍",
            "Pubertal Stage": "青春期阶段",
            "Celiac Disease": "乳糜泻",
            "Hypoglynemic Events": "低血糖事件",
            "Healthy": "健康",
            "Underweight": "体重偏轻",
            "Overweight": "超重",
            "Obesity": "肥胖",
            "Pathway": "途径",
            "Total Enrolled": "总入学人数",
            "Count ": "数数",
            "Percentage": "百分比",
            "Referred For Further Investigation": "提交进一步调查",
            "Not Referred": "未提及",
            "Diagnosed ": "诊断",
            "Not Diagnosed ": "未确诊",
            "On Treatment/ Medical Therapy": "关于治疗/药物疗法",
            "Medical Therapy Not Initiated ": "未开始药物治疗",
            "Cured ": "治愈",
            "Not Cured ": "未治愈",
            "Alerts": "警报",
            "All": "全部",
            "All Follow Alert": "全部关注警报",
            "Days": "天",
            "Details": "细节",
            "Follow Up Alert": "跟进警报",
          "Total people enrolled": "报名总人数",
          "Total T1Ds patient on treatment": "接受治疗的 T1D 患者总数",
          "Total T1D Inactive patient ": "T1D 不活动患者总数",
          "Distribution Of T1D Patients By Gender": "T1D 患者的性别分布",
          "Distribution Of T1D Patients By Age group": "T1D 患者年龄分布",
          "BMI value distribution": "BMI值分布",
          "Diabetes Control Status based on HbA1C\n- Diabetes controlled\n- Diabetes Uncontrolled": "“基于 HbA1C 的糖尿病控制状况\n- 糖尿病得到控制\n- 糖尿病不受控制”",
          "Total Patients With Co-Morbidities": "患有合并症的患者总数",
          "Complication Reporting Rate": "并发症报告率",
          "Home": "家",
          "Pathway": "途径",
          "Linelist": "线路表",
          "Alerts": "警报",
          "Select filter": "选择过滤器",
          "Dashboard": "仪表板",
          "Guinea": "几内亚",
          "Data upload": "数据上传",
          "Data management": "数据管理",
          "User management": "用户管理",
          "Facility management": "设施管理",
          "Activated clients": "已激活客户",
          "Deactivated clients": "已停用的客户端",
          "Search": "搜索",
          "Go to page": "转到页面",
          "Page": "页",
          "Of": "的",
          "Cases": "案例",
          "Show": "展示",
          "UIC": "伊利诺伊大学芝加哥分校",
          "Name": "姓名",
          "Age": "年龄",
          "Gender": "性别",
          "Address": "地址",
          "Deactivate": "停用",
          "Logout": "登出"
      }
  }
};

i18n
  .use(LngDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;